export default __webpack_public_path__ + "static/media/cleanCloseIcon.a4045f5c.svg";